<template>
  <div class="h-full min-h-fit relative bg-white text-gray-900 rounded-lg p-6 text-center">
    <div data-sparks-target="container" class="h-full min-h-fit">
      <div class="flex flex-col h-full justify-center items-center">
        <div class="flex justify-center items-center mb-5 gap-2">
           <img :src="spark_image_url" alt="Spark placeholder">
          <span class="text-7xl font-semibold font-heading">{{ block?.section?.spark?.title || t('slides_editor.components.spark_placeholder.spark') }}</span>
        </div>

        <p class="text-2xl text-gray-700">{{ t('slides_editor.components.spark_placeholder.preview_info') }}</p>
        <p class="text-2xl text-gray-700">{{ t('slides_editor.components.spark_placeholder.competition_info') }}</p>
        <p class="text-2xl text-gray-700"><a target="_blank" href="https://help.wellioeducation.com/interactive-questions-in-wellio#Sparks" class="text-indigo-600">{{ t('slides_editor.components.spark_placeholder.help_link_text') }}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import { t } from '@/libs/i18n'

export default {
  name: 'SparkPlaceholder',
  props: {
    block: {
      type: Object,
      required: true
    },
    spark_image_url: {
      type: String,
      required: true
    }
  },
  setup() {
    return { t }
  }
};
</script>
